import { useQuery } from '@apollo/client/react';
import { type FC, useState } from 'react';

import EditableContentContainer from '@zen/Components/EditableContentContainer';
import QueryHandler from '@zen/Components/QueryHandler';
import { Modal } from '@zen/DesignSystem';

import AccountDetailsItem from '../../components/AccountDetailsItem';
import { AccountFinancialsDocument, type AccountFinancialsQueryResult, type AccountFinancialsQueryVariables } from './graphql';
import type { AccountFinancialsSettings } from './types';
import UpdateAccountFinancialsForm from './UpdateAccountFinancialDetailsForm';
import type { UpdateAccountFinancialsFormInitialValues } from './UpdateAccountFinancialDetailsForm/UpdateAccountFinancialDetailsForm';

interface Props {
  accountId: string;
}

const FinancialsSettingsDetails: FC<Props> = ({ accountId }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { data, loading, error } = useQuery<AccountFinancialsQueryResult, AccountFinancialsQueryVariables>(
    AccountFinancialsDocument,
    { variables: { accountId } }
  );

  const toggleModal = (): void => setIsModalOpen(!isModalOpen);

  return (
    <QueryHandler data={data?.accountFinancials} error={!!error} isLoading={loading}>
      {(accountFinancials: AccountFinancialsSettings) => {
        const initialValues: UpdateAccountFinancialsFormInitialValues = {
          financeId: accountFinancials.financeId || '',
          accountId
        };

        return (
          <>
            <Modal isOpen={isModalOpen} onClose={toggleModal} title="Update finance details">
              <UpdateAccountFinancialsForm initialValues={initialValues} onCancel={toggleModal} onSuccess={toggleModal} />
            </Modal>
            <EditableContentContainer heading="Financials" onEdit={toggleModal}>
              <AccountDetailsItem name="Finance identifier" value={accountFinancials.financeId} />
            </EditableContentContainer>
          </>
        );
      }}
    </QueryHandler>
  );
};

export default FinancialsSettingsDetails;
